import React from 'react';
import Footer from '../components/Footer';
import {
  RiTwitterXLine,
  RiInstagramLine,
  RiFacebookCircleLine,
} from 'react-icons/ri';

import jcbookstore from '../media/jcbookstore.png';
import './Contact.css';

import {socialLinks, contactSections} from '../content/contact/contact';

const iconMap = {
  facebook: RiFacebookCircleLine,
  instagram: RiInstagramLine,
  x: RiTwitterXLine,
};

function Contact() {
  return (
    <div className='Contact'>
      <div className='contactpage'>
        <h1 className='m-0'>Contact</h1>

        <div className='row my-4 my-md-5 m-auto'>
          <div className='col-12 col-md-6 pt-lg-4 contacttext'>
            You can send me a message on
            <br /> Facebook, Instagram and X (Twitter).
            <div className='d-flex iconContainer'>
              {socialLinks.map((s) => {
                const Icon = iconMap[s.id];
                return (
                  <a
                    key={s.id}
                    href={s.url}
                    className='contactlink'
                    target='_blank'
                    rel='noreferrer'
                    aria-label={s.label}
                    title={s.label}>
                    {Icon ? <Icon className='contactlinkicon' /> : null}
                  </a>
                );
              })}
            </div>
            {contactSections.map((section) => (
              <p
                key={section.id}
                className={section.id === 'publicity' ? '' : 'mt-4'}>
                {section.title}
                <br />
                {section.people.map((p) => (
                  <React.Fragment key={p.email}>
                    {p.name}
                    <br />
                    <a
                      href={`mailto:${p.email}`}
                      className='highlight contactlink'
                      target='_blank'
                      rel='noreferrer'>
                      {p.email}
                    </a>
                    <br />
                  </React.Fragment>
                ))}
              </p>
            ))}
          </div>

          <div className='col-md-6 mb-5'>
            <img
              src={jcbookstore}
              alt='Jane Corry showing her new book inside a bookstore'
              className='img-fluid contactimage'
            />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
